import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { BoothfeeComponent } from './boothfee.component';
import { BoothfeeDetailComponent } from './boothfee-detail.component';
import { BoothfeePopupComponent } from './boothfee-dialog.component';
import { BoothfeeDeletePopupComponent } from './boothfee-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class BoothfeeResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const boothfeeRoute: Routes = [
  {
    path: 'boothfee',
    component: BoothfeeComponent,
    resolve: {
      'pagingParams': BoothfeeResolvePagingParams
    },
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.boothfee.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'boothfee/:id',
    component: BoothfeeDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.boothfee.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const boothfeePopupRoute: Routes = [
  {
    path: 'boothfee-new',
    component: BoothfeePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.boothfee.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'boothfee/:id/edit',
    component: BoothfeePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.boothfee.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'boothfee/:id/delete',
    component: BoothfeeDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.boothfee.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/boothfee/boothfee.route.ts